<template>
    <div>
        <data-table-view
            :headers="tableFieldsTasks"
            :items="tasks"
            sort-by="createdAt"
            :sort-desc="true"
            :page="1"
            :items-per-page="20"
            :loading="isDataLoading"
            :computed-fields="computedFieldsTasks"
            :show-select="false"
        ></data-table-view>
    </div>
</template>

<script>
import DataTableView from '@/components/Data/DataTableView';
import { mapState, mapActions } from 'vuex';
import { isEmpty } from '@/common/helpers';

export default {
    name: 'JobDetails',
    components: {
        'data-table-view': DataTableView
    },
    props: {
        jobId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isDataLoading: false
        };
    },
    computed: {
        ...mapState('jobs', [
            'jobTasks',
            'tableFieldsTasks',
            'computedFieldsTasks'
        ]),
        tasks() {
            if (!isEmpty(this.jobTasks) && !isEmpty(this.jobTasks.tasks)) {
                return this.jobTasks.tasks;
            } else {
                return [];
            }
        }
    },
    watch: {
        jobId(value) {
            this.findJobTasks(value);
        }
    },
    methods: {
        ...mapActions('jobs', ['fetchJobTasks']),
        async findJobTasks(jobId) {
            try {
                this.isDataLoading = true;
                if (jobId > 0) {
                    await this.fetchJobTasks({ jobId: this.jobId });
                } else {
                    await this.$store.commit('jobs/setJobTasks', {});
                }
            } finally {
                this.isDataLoading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
